const transformObject = (input) => {
    const transformedObject = {
      //user: input.username,
      displayName: input.displayName,
      role: input.role,
      organization: input.organization,
      pwd: input.password,
      email: input.email,
      town: input.town,
      subOrganization: input.subOrganization
    };
  
    return transformedObject;
  }

  export { transformObject }